<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="isCreateMode ? 'RATIONALISATIONS' : 'UPDATE CARRIER'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div class="mb-3 vx-row">
        <div class="w-full vx-col md:w-1/5 md:mb-0">
            <span class="label">Rationalisation/Factoring (%)</span>
            <vs-input size="large" v-on:input="onChangeInput()" v-model="rationalisation"  name="name" class="w-full" label=""/>
        </div>
      </div>

      <vs-table sort :hoverFlat="true" id="rationalisation_table" noDataText="No raw materials available"  :data="raw_material_items"  stripe class="table-dark-inverted table-auto vs-con-loading__container">

        <template slot="thead">
          <vs-th class="__table-heading-small" width="10%">ITS PROD CODE</vs-th>
          <vs-th class="__table-heading-small" width="10%">PROD NAME</vs-th>
          <vs-th class="__table-heading-small" width="10%">QUANTITY (KG)</vs-th>
          <vs-th class="__table-heading-small" width="10%">PERCENTAGE (%)</vs-th>
          <vs-th class="__table-heading-small font-bold" width="10%">FACTORED QUANTITY (KG)</vs-th>
          <vs-th class="__table-heading-small font-bold" width="10%">FACTORED PERCENTAGE (%)</vs-th>
          <vs-th class="__table-heading-small" width="10%">RM COST IN USE (£/KG)</vs-th>
          <vs-th class="__table-heading-small" width="10%" >RM COST /KG</vs-th>
        </template>

        <template  slot-scope="{data}">
          <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="__table-heading-small" :data="data[indextr].company_product_code">

                      <span v-if="tr.formulation_code" style="cursor: pointer" class="text-primary">
                        {{ data[indextr].formulation_code }}
                      </span>
                      <vx-tooltip v-if="!tr.formulation_code" text="View raw material" position="left">
                              <span style="cursor: pointer" class="text-primary" @click="onClickLinkToRm(data[indextr].id)">
                                {{ data[indextr].category + ' ' +  data[indextr].company_product_code }}
                              </span>
                      </vx-tooltip>
            </vs-td>
            <vs-td class="__table-heading-small">
              <span v-if="tr.company_product_name">{{ data[indextr].company_product_name }}</span>
              <span v-if="tr.name">{{ data[indextr].name }}</span>
            </vs-td>

            <vs-td class="__table-heading-small" :data="data[indextr].quantity">
              {{ data[indextr].quantity }}
            </vs-td>

            <vs-td class="__table-heading-small" >
              {{ data[indextr].percentage }}
            </vs-td>

            <vs-td class="__table-heading-small font-bold" :data="data[indextr].factored_quantity">
              {{ Number(data[indextr].factored_quantity).toFixed(2) }}
            </vs-td>

            <vs-td class="__table-heading-small font-bold" :data="data[indextr].factored_percentage">
              {{ Number(data[indextr].factored_percentage).toFixed(3) }}
            </vs-td>

            <vs-td class="__table-heading-small">
              {{((data[indextr].factored_quantity * data[indextr].cost) / calTotalQuantity()).toFixed(2)}}
            </vs-td>

            <vs-td class="__table-heading-small ml-auto " :data="data[indextr].cost">
              {{(data[indextr].cost).toFixed(2)}}
            </vs-td>

          </vs-tr>
          <vs-tr>
            <vs-td colspan="2">
              <b>Total</b>
            </vs-td>
            <vs-td>{{ calTotalQuantity() }}</vs-td>
            <vs-td>{{ calTotalPercentage() }}</vs-td>
            <vs-td>{{ calTotalFactoredQuantity() }}</vs-td>
            <vs-td>{{ calTotalFactoredPercentage() }}</vs-td>
            <vs-td colspan="2"></vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="vx-row mt-4">
        <div v-can="'edit-formulations'" class="vx-col w-full">
          <vs-button @click.stop="saveFormulations()" class="float-right" color="primary" size="" type="filled">Save changes</vs-button>
        </div>
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      formulationId: '',
      form: {
        name: ''
      },
      isCreateMode: true,
      raw_material_items: [],
      rationalisation: null,
    }
  }

  export default {
    name: 'FormulationRationalisationPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(raw_material_items, formulationId) {
        try {
          Object.assign(this.$data, initialState());
          this.open = true;
          this.formulationId = formulationId
          Object.assign(this.raw_material_items, raw_material_items.map((x) => { x.factored_quantity = x.quantity; x.factored_percentage = x.percentage; return x; }))
        } catch (error) {

        }
      },
      onChangeInput() {
        let carrier = this.raw_material_items.find((n) => n.category && n.category === 'CAR')
        this.raw_material_items =  this.raw_material_items.map((n) => {
          if(n.category !== 'CAR') {
            n.factored_quantity = (Number(n.quantity) * Number(this.rationalisation)) / 100
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })
        let total_factored_quantity = 0
        this.raw_material_items.forEach((n) => {
            if(n.category !== 'CAR') {
              total_factored_quantity =  total_factored_quantity + Number(n.factored_quantity)
            }
        })
        this.raw_material_items =  this.raw_material_items.map((n) => {
          if(n.id === carrier.id) {
            n.factored_quantity = (100 - Number(total_factored_quantity))
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })
      },
      async saveFormulations() {
        const vue = this;
        await this.$vs.loading({
          container: '#rationalisation_table',
          scale: 0.45
        })
        try {
          let rm_items = []
          Object.assign(rm_items, this.raw_material_items)
          const dil_coded_formulations = rm_items
            .filter((x) => x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code)).map((m) => ({
              id: m.id, quantity: m.factored_quantity, manufacture_order: m.manufacture_order
            }))
          const raw_material_items = rm_items
            .filter((x) => !(x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code))).map((m) => ({
              id: m.id, quantity: m.factored_quantity, manufacture_order: m.manufacture_order
            }))
          await FormulationsRepository.updateFormulationsItems(this.formulationId, {raw_material_items: raw_material_items, formulation_items: dil_coded_formulations})
          this.showSuccessMessage('Formulation Updated!')
          this.$emit('refresh')
          this.open = false
        }catch (e) {
          this.$vs.loading.close('#rationalisation_table > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rationalisation_table > .con-vs-loading')
      },
      calTotalQuantity() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.quantity)
        })
        return total.toFixed(2)
      },
      calTotalFactoredQuantity() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.factored_quantity)
        })
        return total.toFixed(2)
      },
      calTotalPercentage() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.percentage)
        })
        return total.toFixed(3)
      },
      calTotalFactoredPercentage() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.factored_percentage)
        })
        return total.toFixed(3)
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      isIncludedDilCodedFormulation() {
        return this.raw_material_items.some((x) => x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code))
      },
      totalFactoredQuantity() {
        return this.raw_material_items.reduce((a, b) => a + Number(b.factored_quantity), 0)
      },
      totalQuantity() {
        return this.raw_material_items.reduce((a, b) => a + Number(b.quantity), 0)
      },
    }
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
  }
  .__table-heading-small{
    font-size: small;
  }

</style>
